import { Box, IconButton, Title, Text } from '@nimbus-ds/components';
import { CloseIcon } from '@nimbus-ds/icons';
import graphicRightSmall from './img/Comp-small.png';
import logo from './img/logoComp.png';
import './D2CBannerDesktop.scss';

interface D2CBannerDesktopProps {
  onClick: () => void;
  onClose: () => void;
}

function D2CBannerDesktop({
  onClick,
  onClose,
}: Readonly<D2CBannerDesktopProps>) {
  return (
    <div className="stratus--banner-desktop desk-width-small">
      <div className="banner__close">
        <IconButton
          onClick={onClose}
          backgroundColor="transparent"
          source={<CloseIcon size="small" />}
        />
      </div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        height="120px"
        paddingLeft="6"
      >
        <img src={logo} />
        <Box display="flex" flexDirection="row" gap="4">
          <Box display="flex" flexDirection="column" gap="2">
            <Title as="h6" fontSize="3-5" color="neutral-background">
              Impulsionando as vendas
              <br />
              online no Brasil
            </Title>
            <Text color="neutral-background">
              30 de setembro e 01 de outubro
              <br />
              Distrito Anhembi – São Paulo
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" gap="2">
            <Box display="flex" flexDirection="column" gap="none">
              <Title as="h6" fontSize="3" color="neutral-background">
                Já são +1000 marcas confirmadas.
              </Title>
              <Text color="neutral-background">
                Você não pode ficar de fora.
              </Text>
            </Box>
            <button className="banner__button" onClick={onClick}>
              <Text>Garanta seu ingresso com 50% off</Text>
            </button>
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end">
          <img
            src={graphicRightSmall}
            alt="Composición de speakers"
            className="banner__graphic"
          />
        </Box>
      </Box>
    </div>
  );
}

export default D2CBannerDesktop;
